import React from "react";
import Card from "../../../../componets/Card";
import { StickerPackInterface } from "../../../../store/sticker_maker/stickerPacksSlice";

const _Details = ({ stickerPack }: { stickerPack: StickerPackInterface | undefined }) => {
  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Keywords</h4>
        {stickerPack?.keywords}
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Search text</h4>
        {stickerPack?.search_text}
      </Card>
    </>
  );
}

export default _Details;
